'use strict';

module.exports = function (rowId, e) {

  if (e) e.stopPropagation();

  var key = 'row_' + rowId;

  if (typeof this.rowsToggleState[key] == 'undefined') {
    this.$set(this.rowsToggleState, key, true);
  } else {
    this.rowsToggleState[key] = !this.rowsToggleState[key];
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/toggle-child-row.js
// module id = 1072
// module chunks = 0